module.exports = __webpack_public_path__ + "static/media/triple-threat-cookie-cake@2x.cf37f516.png";